
import Icon from 'JS/components/Icon.vue';
import { defineComponent, PropType } from 'vue';
import { IAutomotiveWorkOrderLineItemInfo } from 'JS/types/automotive/WorkOrderQuote';

export default defineComponent({
	components: {
		Icon,
	},
	props: {
		info: {
			type: Object as PropType<IAutomotiveWorkOrderLineItemInfo>,
			required: true,
		}
	},
	setup () {


		return {};
	}
});
